import { Skeleton, Stack } from "@mui/material";

export default function WorkerReportSkeleton() {
    return (
        <Stack rowGap={2}>
            <Stack direction="row" gap={2} alignItems="center">
                <Skeleton variant="circular" width={50} height={50} />
                <Skeleton variant="text" width={180} height={24} />
            </Stack>
            <Skeleton variant="rectangular" height={56} />
            <Skeleton variant="rectangular" height={56} />
        </Stack>
    );
}
